var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBotGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53015 0.969971C9.6706 1.1106 9.74949 1.30122 9.74949 1.49997C9.74949 1.69872 9.6706 1.88935 9.53015 2.02997L5.53015 6.02997C5.38953 6.17042 5.1989 6.24931 5.00015 6.24931C4.8014 6.24931 4.61078 6.17042 4.47015 6.02997L0.470153 2.02997C0.396466 1.96131 0.337364 1.87851 0.296372 1.78651C0.25538 1.69451 0.233339 1.5952 0.231562 1.49449C0.229785 1.39379 0.24831 1.29376 0.286031 1.20037C0.323752 1.10698 0.379896 1.02215 0.451115 0.950933C0.522334 0.879714 0.607168 0.823569 0.700556 0.785848C0.793944 0.748127 0.893973 0.729602 0.994676 0.731379C1.09538 0.733156 1.19469 0.755198 1.28669 0.79619C1.37869 0.837182 1.46149 0.896284 1.53015 0.969971L5.00015 4.43997L8.47015 0.969971C8.61078 0.829521 8.8014 0.750631 9.00015 0.750631C9.1989 0.750631 9.38953 0.829521 9.53015 0.969971Z",
    fill: "#004529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBotGreen);
export default __webpack_public_path__ + "static/media/ArrowBotGreen.b1916735a8d9b2d53b31b20d6c445000.svg";
export { ForwardRef as ReactComponent };